// #################################

// Разработано на: RISE PROJECT
// Разработчик: WOTKAD
// Сайт: WOTKAD.RU
// Сайт проекта: WOTKAD.RU/RISE

// #################################

export default function loadImages() {
  let $images = $('img')
  $images.addClass('blur');

  // Проверяем каждое изображение
  $('img').each(function() {

    let $img = $(this);

    // Когда изображение загружено, убираем класс с блюром
    $img.on('load', function() {
      setTimeout(function() {
        $img.removeClass('blur');
      }, 300);
    });

    // Если изображение уже загружено (например, кешированное), убираем блюр сразу
    if ($img[0].complete) {
      setTimeout(function() {
        $img.removeClass('blur');
      }, 300);
    }
  });
}
loadImages();

import "./base/common/preloader";
import "./base/common/smooth-scroll";
import "./base/common/scroll-reveal";
import "./base/common/scroll-rellax";
import "./base/common/copy-address";

import "./base/common/get-current-year";
import "./base/common/get-height";

import "./components/toggle/toggle-mobile-menu";
import "./components/toggle/toggle-chat";
import "./components/toggle/toggle-filter";
import "./components/toggle/toggle-courses-filter";
import "./components/toggle/toggle-promo-filter";
import "./components/toggle/toggle-events-filter";
import "./components/toggle/toggle-questions";
import "./components/toggle/toggle-payment-page";
import "./components/toggle/toggle-education-programs";
import "./components/toggle/toggle-share";
import "./components/toggle/toggle-teacher-blocks";
import "./components/toggle/toggle-reviews";
import "./components/toggle/toggle-line-clamp";
import "./components/toggle/toggle-webtip";

import "./components/scroll/scroll-header";

import "./components/animations/animations-hero";

import "./components/slider/slider-results";
import "./components/slider/slider-events";
import "./components/slider/slider-materials";
import "./components/slider/slider-teachers";
import "./components/slider/slider-reviews";
import "./components/slider/slider-contacts";
import "./components/slider/slider-more";
import "./components/slider/slider-teacher";
import "./components/slider/slider-other-teachers";
import "./components/slider/slider-courses";
import "./components/slider/slider-event";
import "./components/slider/slider-stories";
import "./components/slider/slider-stories-carousel";
import "./components/slider/slider-related-posts";

import "./components/form/callback-form";
import "./components/form/certificate-form";
import "./components/form/teacher-form";
import "./components/form/input-mask";

import "./components/gallery";
import "./components/timer";

import "./components/popup/popup-age";
import "./components/popup/popup-location";
import "./components/popup/popup-cookie";
import "./components/popup/popup-old";
import "./components/popup/popup-not-working";
import "./components/popup/popup";
